// Satır durum renkleri token'dan gelir → açık/koyu temada renk açıklama kareleri satırlarla aynı kalır (bkz. brand.css).
const Colors = {
    selectedRow: 'var(--accent-row)',    // marka amber'inden türer (bkz. brand.css)
    confirmedRow: 'var(--row-confirmed)', // onaylı rapor / raporu var (bkz. brand.css)
    deletedRow: 'var(--row-deleted)',
    emergencyRow: 'var(--row-emergency)',
    noReportRow: 'var(--row-no-report)',
    notConfirmedRow: 'var(--row-not-confirmed)',
    dashRoutine: 'var(--dash-routine)',
    dashRoutineSum: 'var(--dash-routine-sum)',
    dashEmergency: 'var(--dash-emergency)',
    dashEmergencySum: 'var(--dash-emergency-sum)',
}

export default Colors
